import { getClassNames } from '@websolutespa/bom-core';
import { useDateTimeFormat, useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmTrash } from '@websolutespa/bom-mixer-icons';
import { LlmHistory } from '../../../types';
import { useLlm } from '../../../useLlm/useLlm';
import style from './page-history.module.scss';

export const PageHistory: React.FC<{ item: LlmHistory }> = ({ item }) => {
  const label = useLabel();
  const dateFormat = useDateTimeFormat({
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  });
  const timeFormat = useDateTimeFormat({
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  });
  const { setHistory, removeHistory } = useLlm(state => state.actions);
  // console.log('item', item);
  if (!item.user) {
    return;
  }
  return (
    <div className={getClassNames(style.history)} onClick={() => setHistory(item)}>
      {item.createdAt && (
        <div className={style.head}>
          <div className={style.date}>{dateFormat(item.createdAt)}</div>
          <div className={style.time}>{timeFormat(item.createdAt)}</div>
        </div>
      )}
      <div className={style.user}>{item.user.text}</div>
      <div className={style.foot}>
        {item.assistant ? (
          <div className={style.assistant}>{item.assistant.text}</div>
        ) : (
          <div className={style.assistant}>{label('llm.reasoning')}</div>
        )}
        {item.messageId && (
          <button className={style.delete} onClick={(event) => {
            event.stopPropagation();
            removeHistory(item);
          }}>
            <IconLlmTrash />
          </button>
        )}
      </div>
    </div>
  );
};
